<template>
  <div>
    <!-- card filter -->
    <b-card no-body>
      <b-card-header>
        <b-card-title>Input Data</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'perkin' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            md="10"
            offset-md="1"
          >
            <b-overlay
              :show="isShowFormVal"
              variant="light"
              opacity="0.85"
              blur="2px"
              rounded="sm"
            >
              <!-- input wilayah -->
              <b-form-group
                label="Wilayah"
                label-for="wilayah"
              >
                <b-form-select
                  id="wilayah"
                  v-model="wilayah"
                  :options="dataWilayah"
                />
              </b-form-group>

              <b-col
                v-if="wilayah"
                cols="12"
                class="text-right pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="btn-icon"
                  @click="clickCari"
                >
                  <div v-if="isCari">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <span v-else>Cari</span>
                </b-button>
              </b-col>
            </b-overlay>
          </b-col>
          <b-col
            v-if="wilayah"
            md="12"
            class="pt-1"
          >
            <b-overlay
              :show="isCari"
              variant="light"
              opacity="0.85"
              blur="2px"
              rounded="sm"
            >
              <b-table
                responsive
                :items="itemBmd"
                :fields="kolomBmd"
                class="pt-1"
                striped
              >
                <template #thead-top>
                  <b-tr>
                    <b-th>Kolok</b-th>
                    <b-th>Nalok</b-th>
                    <b-th
                      colspan="2"
                      class="text-center"
                    >
                      Persiapan
                    </b-th>
                    <b-th
                      colspan="3"
                      class="text-center"
                    >
                      Pelaporan
                    </b-th>
                  </b-tr>
                </template>

                <template #cell(persiapanTim)="data">
                  <b-form-checkbox
                    v-model="dataPerkin[data.index].persiapanTim"
                    value="1"
                    :disabled="
                      dataPerkinDisable[data.index].isDisablePersiapanTim
                    "
                  />
                </template>
                <template #cell(persiapanJadwal)="data">
                  <b-form-checkbox
                    v-model="dataPerkin[data.index].persiapanJadwal"
                    value="1"
                    :disabled="
                      dataPerkinDisable[data.index].isDisablePersiapanJadwal
                    "
                  />
                </template>
                <template #cell(pelaporanSptjm)="data">
                  <b-form-checkbox
                    v-model="dataPerkin[data.index].pelaporanSptjm"
                    value="1"
                    :disabled="
                      dataPerkinDisable[data.index].isDisablePelaporanSptjm
                    "
                  />
                </template>
                <template #cell(pelaporanBa)="data">
                  <b-form-checkbox
                    v-model="dataPerkin[data.index].pelaporanBa"
                    value="1"
                    :disabled="
                      dataPerkinDisable[data.index].isDisablePelaporanBa
                    "
                  />
                </template>
                <template #cell(pelaporanLaporan)="data">
                  <b-form-checkbox
                    v-model="dataPerkin[data.index].pelaporanLaporan"
                    value="1"
                    :disabled="
                      dataPerkinDisable[data.index].isDisablePelaporanLaporan
                    "
                  />
                </template>
              </b-table>

              <b-col
                offset-md="1"
                cols="10"
                class="text-right pr-0"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="btn-icon"
                  @click="submitForm"
                >
                  <div v-if="isSubmit">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <span v-else>Simpan</span>
                </b-button>
              </b-col>
            </b-overlay>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BRow,
  BTable,
  BFormFile,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BFormTextarea,
  BOverlay,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import apiMaster from '@/composables/master'
import apiPerkin from '@/composables/perkin'

export default {
  setup(props, context) {
    const g = context.root

    const isSubmit = ref(false)

    const isCari = ref(false)

    // form name
    const wilayah = ref(null)

    const cookiesFilterWilayah = JSON.parse(
      g.$cookies.get('filterWilayahPerkin'),
    )

    const kolomBmd = ref([
      {
        key: 'kolok',
        label: '',
      },
      {
        key: 'nalok',
        label: '',
      },
      {
        key: 'persiapanTim',
        label: 'Tim',
      },
      {
        key: 'persiapanJadwal',
        label: 'Jadwal',
      },
      {
        key: 'pelaporanSptjm',
        label: 'SPTJM',
      },
      {
        key: 'pelaporanBa',
        label: 'Berita Acara',
      },
      {
        key: 'pelaporanLaporan',
        label: 'Laporan',
        tdClass: 'text-center',
      },
    ])

    const itemBmd = ref([])
    const dataPerkin = ref([])
    const dataPerkinDisable = ref([])

    const dataWilayah = ref([])

    const submitForm = async () => {
      isSubmit.value = true

      itemBmd.value = itemBmd.value.map((item, i) => ({
        ...item,
        persiapanTim:
          dataPerkin.value[i].persiapanTim == 1
            ? dataPerkin.value[i].persiapanTim
            : 0,
        persiapanJadwal:
          dataPerkin.value[i].persiapanJadwal == 1
            ? dataPerkin.value[i].persiapanJadwal
            : 0,
        pelaporanSptjm:
          dataPerkin.value[i].pelaporanSptjm == 1
            ? dataPerkin.value[i].pelaporanSptjm
            : 0,
        pelaporanBa:
          dataPerkin.value[i].pelaporanBa == 1
            ? dataPerkin.value[i].pelaporanBa
            : 0,
        pelaporanLaporan:
          dataPerkin.value[i].pelaporanLaporan == 1
            ? dataPerkin.value[i].pelaporanLaporan
            : 0,
      }))

      const data = {
        updatePerkin: itemBmd.value,
      }

      await apiPerkin.submit(g, data, props.action)
      isSubmit.value = false
    }

    const getWilayah = async () => {
      const resWilayah = await apiMaster.getWilayah(g)
      dataWilayah.value = []
      resWilayah.forEach(item => {
        if (cookiesFilterWilayah.length > 0) {
          const index = cookiesFilterWilayah.findIndex(
            item2 => item2 == item.value,
          )
          if (index >= 0) dataWilayah.value.push(item)
        }
        // else dataWilayah.value.push(item);
      })
      dataWilayah.value.unshift({
        text: '-- Pilih Salah Satu --',
        value: null,
      })
    }

    getWilayah()

    const getPdUpd = async (searchPdUpd = '') => {
      // if (wilayahFilter.value) {
      //   let params = {
      //     filter_ukpd: pdUpdFilter.value,
      //     length: perPageSummary.value,
      //     start: (currentPageSummary.value - 1) * perPageSummary.value,
      //     // search: searchQueryDashboardSummary.value,
      //     kode_wilayah: wilayahFilter.value,
      //   };
      //   let resPerkin = await apiPerkin.getListPerkin(g, params);
      //   const { code, data, totalData } = resPerkin;
      // }
      isCari.value = true
      // let params = {
      //   cari: searchPdUpd,
      //   wilayah: wilayah.value,
      // };
      // let resPdUpd = await apiMaster.getPdUpd(g, params);
      itemBmd.value = []
      dataPerkin.value = []

      // resPdUpd.map((item, i) => {
      //   itemBmd.value.push({
      //     kolok: item.value,
      //     nalok: item.text,
      //   });
      //   dataPerkin.value.push({
      //     persiapanTim: false,
      //     persiapanJadwal: false,
      //     pelaporanSptjm: false,
      //     pelaporanBa: false,
      //     pelaporanLaporan: false,
      //   });
      // });

      const params = {
        filter_ukpd: searchPdUpd,
        length: 10000000,
        start: 0,
        kode_wilayah: wilayah.value,
      }
      const resPerkin = await apiPerkin.getListPerkin(g, params)
      const { code, data } = resPerkin

      if (code == 200) {
        let persiapanTim = 0
        let persiapanJadwal = 0
        let pelaporanSptjm = 0
        let pelaporanBa = 0
        let pelaporanLaporan = 0

        let isDisablePersiapanTim = false
        let isDisablePersiapanJadwal = false
        let isDisablePelaporanSptjm = false
        let isDisablePelaporanBa = false
        let isDisablePelaporanLaporan = false

        for (let i = 0; i < data.length; i++) {
          isDisablePersiapanTim = false
          isDisablePersiapanJadwal = false
          isDisablePelaporanSptjm = false
          isDisablePelaporanBa = false
          isDisablePelaporanLaporan = false

          const item = data[i]
          itemBmd.value.push({
            kolok: item.kolok,
            nalok: item.nalok,
          })

          if (
            moment(item.tw1Start).isSameOrBefore(moment())
            && moment(item.tw1End).isSameOrAfter(moment())
          ) {
            persiapanTim = item.persiapanTimTw1
            persiapanJadwal = item.persiapanJadwalTw1
            pelaporanSptjm = item.pelaporanSptjmTw1
            pelaporanBa = item.pelaporanBaTw1
            pelaporanLaporan = item.pelaporanLhTw1
          } else if (
            moment(item.tw2Start).isSameOrBefore(moment())
            && moment(item.tw2End).isSameOrAfter(moment())
          ) {
            if (item.persiapanTimTw1 == 1) {
              isDisablePersiapanTim = true
              persiapanTim = 1
            } else persiapanTim = item.persiapanTimTw2

            if (item.persiapanJadwalTw1 == 1) {
              isDisablePersiapanJadwal = true
              persiapanJadwal = 1
            } else persiapanJadwal = item.persiapanJadwalTw2

            if (item.pelaporanSptjmTw1 == 1) {
              isDisablePelaporanSptjm = true
              pelaporanSptjm = 1
            } else {
              isDisablePelaporanSptjm = item.hasilSensusTw2 != item.jumlahBmd
              pelaporanSptjm = item.pelaporanSptjmTw2
            }

            if (item.pelaporanBaTw1 == 1) {
              isDisablePelaporanBa = true
              pelaporanBa = 1
            } else {
              isDisablePelaporanBa = item.hasilSensusTw2 != item.jumlahBmd
              pelaporanBa = item.pelaporanBaTw2
            }

            if (item.pelaporanLhTw1 == 1) {
              isDisablePelaporanLaporan = true
              pelaporanLaporan = 1
            } else {
              isDisablePelaporanLaporan = item.hasilSensusTw2 != item.jumlahBmd
              pelaporanLaporan = item.pelaporanLhTw2
            }
          } else if (
            moment(item.tw3Start).isSameOrBefore(moment())
            && moment(item.tw3End).isSameOrAfter(moment())
          ) {
            if (item.persiapanTimTw2 == 1) {
              isDisablePersiapanTim = true
              persiapanTim = 1
            } else persiapanTim = item.persiapanTimTw3

            if (item.persiapanJadwalTw2 == 1) {
              isDisablePersiapanJadwal = true
              persiapanJadwal = 1
            } else persiapanJadwal = item.persiapanJadwalTw3

            if (item.pelaporanSptjmTw2 == 1) {
              isDisablePelaporanSptjm = true
              pelaporanSptjm = 1
            } else {
              isDisablePelaporanSptjm = item.hasilSensusTw3 != item.jumlahBmd
              pelaporanSptjm = item.pelaporanSptjmTw3
            }

            if (item.pelaporanBaTw2 == 1) {
              isDisablePelaporanBa = true
              pelaporanBa = 1
            } else {
              isDisablePelaporanBa = item.hasilSensusTw3 != item.jumlahBmd
              pelaporanBa = item.pelaporanBaTw3
            }

            if (item.pelaporanLhTw2 == 1) {
              isDisablePelaporanLaporan = true
              pelaporanLaporan = 1
            } else {
              isDisablePelaporanLaporan = item.hasilSensusTw3 != item.jumlahBmd
              pelaporanLaporan = item.pelaporanLhTw3
            }
          } else if (
            moment(item.tw4Start).isSameOrBefore(moment())
            && moment(item.tw4End).isSameOrAfter(moment())
          ) {
            if (item.persiapanTimTw3 == 1) {
              isDisablePersiapanTim = true
              persiapanTim = 1
            } else persiapanTim = item.persiapanTimTw4

            if (item.persiapanJadwalTw3 == 1) {
              isDisablePersiapanJadwal = true
              persiapanJadwal = 1
            } else persiapanJadwal = item.persiapanJadwalTw4

            if (item.pelaporanSptjmTw3 == 1) {
              isDisablePelaporanSptjm = true
              pelaporanSptjm = 1
            } else {
              isDisablePelaporanSptjm = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanSptjm = item.pelaporanSptjmTw4
            }

            if (item.pelaporanBaTw3 == 1) {
              isDisablePelaporanBa = true
              pelaporanBa = 1
            } else {
              isDisablePelaporanBa = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanBa = item.pelaporanBaTw4
            }

            if (item.pelaporanLhTw3 == 1) {
              isDisablePelaporanLaporan = true
              pelaporanLaporan = 1
            } else {
              isDisablePelaporanLaporan = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanLaporan = item.pelaporanLhTw4
            }
          } else {
            if (item.persiapanTimTw3 == 1) {
              isDisablePersiapanTim = true
              persiapanTim = 1
            } else persiapanTim = item.persiapanTimTw4

            if (item.persiapanJadwalTw3 == 1) {
              isDisablePersiapanJadwal = true
              persiapanJadwal = 1
            } else persiapanJadwal = item.persiapanJadwalTw4

            if (item.pelaporanSptjmTw3 == 1) {
              isDisablePelaporanSptjm = true
              pelaporanSptjm = 1
            } else {
              isDisablePelaporanSptjm = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanSptjm = item.pelaporanSptjmTw4
            }

            if (item.pelaporanBaTw3 == 1) {
              isDisablePelaporanBa = true
              pelaporanBa = 1
            } else {
              isDisablePelaporanBa = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanBa = item.pelaporanBaTw4
            }

            if (item.pelaporanLhTw3 == 1) {
              isDisablePelaporanLaporan = true
              pelaporanLaporan = 1
            } else {
              isDisablePelaporanLaporan = item.hasilSensusTw4 != item.jumlahBmd
              pelaporanLaporan = item.pelaporanLhTw4
            }
          } 

          dataPerkin.value.push({
            persiapanTim,
            persiapanJadwal,
            pelaporanSptjm,
            pelaporanBa,
            pelaporanLaporan,
          })

          dataPerkinDisable.value.push({
            isDisablePersiapanTim,
            isDisablePersiapanJadwal,
            isDisablePelaporanSptjm,
            isDisablePelaporanBa,
            isDisablePelaporanLaporan,
          })
        }
      }
      isCari.value = false
    }

    const clickCari = async () => {
      getPdUpd()
    }

    return {
      isSubmit,
      isCari,

      wilayah,

      kolomBmd,
      itemBmd,
      dataPerkinDisable,

      dataPerkin,
      dataWilayah,

      clickCari,
      submitForm,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BRow,
    BTable,
    BFormFile,
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
  },
  props: {
    action: String,
    id: String,
    isShowFormVal: Boolean,
  },
}
</script>
